/*
  Cart drawer interactions (CART_DRAWER_SPEC.md §2–4, §9–10) for the tiles
  rendered by snippets/brissta-cart-line.liquid.

  Every action posts to the Shopify Cart AJAX API with the cart drawer's
  section id, so the response carries freshly rendered drawer HTML; that is
  handed to window.brisstaApplyCartChange (layout/theme.liquid), which syncs
  the theme's cart store and the drawer DOM. No client-side cart model, no
  DOM patching — every change re-renders from Shopify's cart.

    [data-bc-action="dec" | "inc"]  quantity −1 / +1 (1–5; −1 at 1 removes)
    [data-bc-qty-input]             typed quantity (Enter/blur), ↑/↓ step
    [data-bc-action="remove"]       remove the line
    [data-bc-action="remove-gift"]  remove the gift and mark it declined for
                                    this cart (cart attribute _gift_declined)
    [data-bc-action="upgrade"]      one-time → subscription on the same line
                                    (data-plan = selling plan id)
*/
(function () {
  'use strict';
  if (window.__brisstaCartWired) return;
  window.__brisstaCartWired = true;

  var MAX_QTY = 5;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function post(path, body) {
    var mini = document.querySelector('xo-cart-mini');
    if (mini && mini.id) {
      body.sections = mini.id;
      body.sections_url = window.location.pathname;
    }
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Cart update failed');
        return data;
      });
    });
  }

  function apply(data) {
    if (typeof window.brisstaApplyCartChange === 'function') window.brisstaApplyCartChange(data);
  }

  function lock(tile, control) {
    tile.setAttribute('data-loading', '');
    tile.querySelectorAll('button, input').forEach(function (el) { el.disabled = true; });
    if (control) control.classList.add('is-loading');
  }

  function unlock(tile, control) {
    // Normally the tile is replaced by the re-render; this only runs on error.
    tile.removeAttribute('data-loading');
    tile.querySelectorAll('button, input').forEach(function (el) { el.disabled = false; });
    if (control) control.classList.remove('is-loading');
  }

  function run(tile, control, request) {
    lock(tile, control);
    request.then(apply).catch(function (err) {
      console.error('[brissta-cart]', err);
      unlock(tile, control);
    });
  }

  function setQuantity(tile, control, qty) {
    var key = tile.getAttribute('data-key');
    qty = Math.max(0, Math.min(MAX_QTY, qty));
    if (qty === parseInt(tile.getAttribute('data-qty'), 10)) return;
    run(tile, control, post('cart/change.js', { id: key, quantity: qty }));
  }

  document.addEventListener('click', function (e) {
    var control = e.target.closest && e.target.closest('[data-bc-action]');
    if (!control) return;
    var tile = control.closest('[data-bc-line]');
    if (!tile || tile.hasAttribute('data-loading')) return;
    e.preventDefault();
    var key = tile.getAttribute('data-key');
    var qty = parseInt(tile.getAttribute('data-qty'), 10) || 1;

    switch (control.getAttribute('data-bc-action')) {
      case 'dec':
        setQuantity(tile, control, qty - 1);
        break;
      case 'inc':
        setQuantity(tile, control, qty + 1);
        break;
      case 'remove':
        run(tile, control, post('cart/change.js', { id: key, quantity: 0 }));
        break;
      case 'remove-gift':
        var updates = {};
        updates[key] = 0;
        run(tile, control, post('cart/update.js', { updates: updates, attributes: { _gift_declined: '1' } }));
        break;
      case 'upgrade':
        var plan = parseInt(control.getAttribute('data-plan'), 10);
        if (plan) run(tile, control, post('cart/change.js', { id: key, quantity: qty, selling_plan: plan }));
        break;
    }
  });

  function commitInput(input) {
    var tile = input.closest('[data-bc-line]');
    if (!tile || tile.hasAttribute('data-loading')) return;
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < 1) value = 1;
    setQuantity(tile, null, value);
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-bc-qty-input]')) commitInput(e.target);
  });

  document.addEventListener('keydown', function (e) {
    var input = e.target;
    if (!(input.matches && input.matches('[data-bc-qty-input]'))) return;
    var tile = input.closest('[data-bc-line]');
    var qty = parseInt(tile.getAttribute('data-qty'), 10) || 1;
    if (e.key === 'ArrowUp') { e.preventDefault(); setQuantity(tile, null, qty + 1); }
    else if (e.key === 'ArrowDown') { e.preventDefault(); setQuantity(tile, null, Math.max(1, qty - 1)); }
    else if (e.key === 'Enter') { e.preventDefault(); commitInput(input); }
  });
})();
